/** Route for premium upgrade / subscription management (not profile). */
export const SUBSCRIPTION_UPGRADE_PATH = "/subscription";

/**
 * Navigate free users to the subscription upgrade flow.
 */
export function getPremiumUpgradePath(): string {
  return SUBSCRIPTION_UPGRADE_PATH;
}
